<template>
  <div
    className="ContactSection"
    id="contact"
    :style="{
      'background-image':
        'url(' + require('@/assets/images/mountains.jpg') + ')',
    }"
  >
    <h1 className="ContactSectionHeader">KONTAKT</h1>
    <Contact />
  </div>
</template>

<script>
import Contact from "@/Components/Contact";

export default {
  setup() {},
  components: {
    Contact,
  },
};
</script>

<style scoped>
h1.ContactSectionHeader {
  color: white;
  text-align: center;
  padding-top: 200px;
  padding-bottom: 100px;
  font-size: 100px;
  font-weight: 200;
  letter-spacing: 40px;
  text-shadow: 0px 3px 3px black;
}

.ContactSection {
  min-height: 600px;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding-bottom: 100px;
}
</style>
